import { PaymentOrderPlan } from "./payment.types";
import { FileObject, GeoLocation } from "./shared.types";

export enum UserRole {
  ALPHA = "alpha",
  MUSE = "muse",
}
export enum UserStatus {
  NOT_ONBOARDED = "not-onboarded",
  PENDING = "pending",
  NOT_FINISHED_PROFILE = "not-finished-profile",
  INACTIVE = "inactive",
  ACTIVE = "active",
  REJECTED = "rejected",
}
export type UserSocialLinks = {
  instagram: string;
};
export type UserSubscription = {
  availableTo: string;
  lastPaidAt: string;
  plan: PaymentOrderPlan;
  product: {
    price: number;
  };
};
export enum UserReferralRequestStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}
export type UserReferralRequest = {
  id: string;
  status: UserReferralRequestStatus;
  referral: User;
  referrer: User;
  createdAt: string;
};
export type UserAccomplishment = {
  description: string;
  link: string;
};

export type User = {
  id: string;
  email: string;
  role: UserRole;
  status: UserStatus;
  firstName: string;
  lastName: string;
  lastSeen: string;
  createdAt: string;
  phoneNumber: string;
  dateOfBirth: string;
  remainingInvitesCount: number;
  locationOrigin: GeoLocation;
  locationResidence: GeoLocation;
  vettingNote?: string;
  referrer?: User;
  occupation?: string;
  locationWorkplace?: string;
  accomplishments?: UserAccomplishment[];
  referralRequests?: UserReferralRequest[];
  profileImage?: FileObject;
  completedOnboardingAt?: string;
  socialLinks?: UserSocialLinks;
  subscription?: UserSubscription;
  isDeleted?: boolean;
};
